import { render, staticRenderFns } from "./UnstarredQuestion.vue?vue&type=template&id=80c2c31e&scoped=true&"
import script from "./UnstarredQuestion.vue?vue&type=script&lang=ts&"
export * from "./UnstarredQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=80c2c31e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c2c31e",
  null
  
)

export default component.exports